import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import Logo from '../../../components/Logo';

const navLinks = [
  { label: '核心功能', href: '/#features' },
  { label: '数据看板', href: '/#dashboard' },
  { label: '使用步骤', href: '/#steps' },
  { label: '价格方案', href: '/pricing' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl h-16 md:h-20 flex items-center justify-between">
          <Link to="/">
            <Logo />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
              link.href.startsWith('/#') ? (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              )
            )}
          </div>

          <div className="hidden md:flex items-center gap-3">
            {user ? (
              <Link
                to="/sites"
                className="px-5 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap"
              >
                进入工作台
              </Link>
            ) : (
              <>
                <Link
                  to="/login"
                  className="px-4 py-2 text-sm font-semibold text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  登录
                </Link>
                <Link
                  to="/register"
                  className="px-5 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap"
                >
                  免费注册
                </Link>
              </>
            )}
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900"
            aria-label="打开菜单"
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>

        {menuOpen && (
          <div className="md:hidden pb-4 flex flex-col gap-1">
            {navLinks.map((link) =>
              link.href.startsWith('/#') ? (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-md"
                >
                  {link.label}
                </Link>
              )
            )}
            <div className="flex items-center gap-3 px-3 pt-2">
              {user ? (
                <Link
                  to="/sites"
                  onClick={() => setMenuOpen(false)}
                  className="flex-1 text-center px-4 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 rounded-md"
                >
                  进入工作台
                </Link>
              ) : (
                <>
                  <Link
                    to="/login"
                    onClick={() => setMenuOpen(false)}
                    className="flex-1 text-center px-4 py-2.5 text-sm font-semibold text-foreground-800 border border-background-300 rounded-md"
                  >
                    登录
                  </Link>
                  <Link
                    to="/register"
                    onClick={() => setMenuOpen(false)}
                    className="flex-1 text-center px-4 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 rounded-md"
                  >
                    免费注册
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
